import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Home, ArrowLeft } from 'lucide-react';

const NotFoundPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-gray-100 flex items-center justify-center">
      <Helmet>
        <title>404 - Page Not Found | Nix Spaces</title>
        <meta name="description" content="The page you're looking for doesn't exist." />
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>

      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="bg-white rounded-3xl p-12 shadow-xl border border-gray-100">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-cyan-100 mb-6">
            <span className="text-4xl font-bold text-cyan-600">404</span>
          </div>
          
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Page Not Found
          </h1>
          
          <p className="text-xl text-gray-600 mb-8">
            Sorry, the page you're looking for doesn't exist or has been moved.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/"
              className="inline-flex items-center justify-center space-x-2 bg-cyan-500 text-white px-8 py-4 rounded-2xl text-lg font-semibold hover:bg-cyan-600 transition-all duration-300 shadow-lg hover:shadow-xl"
            >
              <Home className="h-5 w-5" />
              <span>Go to Homepage</span>
            </Link>
            
            <button
              onClick={() => window.history.back()}
              className="inline-flex items-center justify-center space-x-2 border-2 border-cyan-500 text-cyan-500 px-8 py-4 rounded-2xl text-lg font-semibold hover:bg-cyan-500 hover:text-white transition-all duration-300 shadow-lg hover:shadow-xl"
            >
              <ArrowLeft className="h-5 w-5" />
              <span>Go Back</span>
            </button>
          </div>
          
          <div className="mt-12 pt-8 border-t border-gray-200">
            <p className="text-gray-600 mb-4">Looking for something specific?</p>
            <div className="flex flex-wrap justify-center gap-4 text-sm">
              <Link to="/warehouse-phone-monitoring" className="text-cyan-600 hover:underline">
                Warehouse Monitoring
              </Link>
              <Link to="/industrial-safety-monitoring" className="text-cyan-600 hover:underline">
                Industrial Safety
              </Link>
              <Link to="/pricing" className="text-cyan-600 hover:underline">
                Pricing
              </Link>
              <Link to="/shift-distraction-policy-kit" className="text-cyan-600 hover:underline">
                Policy Kit
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
